import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './TimePicker.css';
import styles from './StoreNotAvailable.css';
import TimeSwitch from './TimeSwitch/TimeSwitch';
import SingleTime from './SingleTime/SingleTime';
import { bookingProcessSelectTime, bookingProcessSetStep, changeServiceSelected } from '../../store/actions/bookingProcess';
import { LogoLoader } from '../UI/Loader/LogoLoader';
import { StoreNotAvailable } from './StoreNotAvailable';
import { changeStoreModalStart } from '../../store/actions/changeStoreModal';

import Button from "../UI/Button/Button";

const arrayCutter = (arrayToCut, maxLength) => {
  let newArray = [...arrayToCut];
  let cuttedArray = [];
  while (newArray.length > maxLength) {
    let chunk = newArray.slice(0, maxLength);
    newArray.splice(0, maxLength);
    cuttedArray.push(chunk);
  }
  if (newArray.length > 0) {
    cuttedArray.push(newArray);
  }
  return cuttedArray;
};

class TimePicker extends Component {

  onTimeSwitchChange = () => {
    this.props.changeSelectedService(!this.props.isServiceSelectedEvening);
  }

  timeSelectedHandled = (data) => {
    this.props.onSelectTime(data);
  }

  onChangeStore = (covers, date) => {
    this.props.changeStore(covers, date);
  }

  render() {
    const availableTimes = this.props.availableTimes[this.props.dateSelected] || null;
    let renderLunch = null, renderDinner = null;

    let isLunchTimesAvailable = false;
    let isDinnerTimesAvailable = false;

    if (availableTimes) {
      if (availableTimes.isFetching) {
        renderLunch = <LogoLoader />
        renderDinner = <LogoLoader />
      }
      else if (availableTimes.error) {
        renderLunch = <StoreNotAvailable
          isError={true}
          onClick={() => this.onChangeStore(this.props.covers, this.props.dateSelected)}
        />
        renderDinner = <StoreNotAvailable
          isError={true}
          onClick={() => this.onChangeStore(this.props.covers, this.props.dateSelected)}
        />
      } else {
        if (availableTimes.lunchTimes) {
          if (availableTimes.lunchTimes.length === 0) {
            renderLunch = <StoreNotAvailable
              onClick={() => this.onChangeStore(this.props.covers, this.props.dateSelected)}
            />
          } else {
            isLunchTimesAvailable = true;
            renderLunch = arrayCutter([...availableTimes.lunchTimes], 4)
              .map((row, index) => {
                let timesToStyle = row.map(t => t.time);
                let timeLayout = [];
                let spacingClass = '';
                if (index > 0) { spacingClass = 'Margin20' }
                timesToStyle.map(time => {
                  timeLayout.push(<SingleTime
                    clicked={() => this.timeSelectedHandled(time)}
                    time={time}
                    key={time}
                    spacing={spacingClass}
                    active={time === this.props.timeSelected}
                  />)
                  return null;
                });
                while (timeLayout.length < 4) {
                  let index = timeLayout.length;
                  timeLayout.push(<div className={classes.Filler} key={index}></div>)
                }
                return (<div className={classes.RowSpaced} key={index}>{timeLayout}</div>)
              });
          }
        }

        if (availableTimes.dinnerTimes) {
          if (availableTimes.dinnerTimes.length === 0) {
            renderDinner = <StoreNotAvailable
              onClick={() => this.onChangeStore(this.props.covers, this.props.dateSelected)}
            />
          } else {
            isDinnerTimesAvailable = true;
            renderDinner = arrayCutter([...availableTimes.dinnerTimes], 4)
              .map((row, index) => {
                let timesToStyle = row.map(t => t.time);
                let timeLayout = [];
                let spacingClass = '';
                if (index > 0) { spacingClass = 'Margin20' }
                timesToStyle.map(time => {
                  timeLayout.push(<SingleTime
                    clicked={() => this.timeSelectedHandled(time)}
                    time={time}
                    key={time}
                    spacing={spacingClass}
                    active={time === this.props.timeSelected}
                  />)
                  return null;
                });
                while (timeLayout.length < 4) {
                  let index = timeLayout.length;
                  timeLayout.push(<div className={classes.Filler} key={index}></div>)
                }

                return (<div className={classes.RowSpaced} key={index}>{timeLayout}</div>)
              });
          }
        }
      }
    }

    let timeList = this.props.isServiceSelectedEvening ? renderDinner : renderLunch;
    let areTimesAvailable = this.props.isServiceSelectedEvening ? isDinnerTimesAvailable : isLunchTimesAvailable;

    let availabilityTranslationsComponent = null;
    if (areTimesAvailable && this.props.availabilityTranslations) {
      availabilityTranslationsComponent = <div style={{ maxWidth: '340px' }}>
        {this.props.availabilityTranslations.primaryTitle && <p className={styles.AvailabilityTitle}>{this.props.availabilityTranslations.primaryTitle}</p>}
        <p className={styles.AvailabilityMessage}>{this.props.availabilityTranslations.primaryMessageAvailable}</p>
        <div className={styles.StoreNotAvailableButtonContainer}>
          <Button btnLabel={<a className={styles.PhoneLink} href={`tel:${this.props.phone}`}>{this.props.phone}</a>} />
        </div>
      </div>
    }

    return (
      <div className={classes.Container}>
        <TimeSwitch
          translations={this.props.translations}
          action={this.onTimeSwitchChange}
          isServiceSelectedEvening={this.props.isServiceSelectedEvening}
        />
        <p className={classes.Text}>{this.props.translations.label_schedule}</p>
        <div className={classes.TimeList}>
          {timeList}
        </div>
        {availabilityTranslationsComponent}
        <div className={classes.Spacer}></div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateSelected: state.bookingProcessReducer.dateSelected,
    timeSelected: state.bookingProcessReducer.timeSelected,
    availableTimes: state.bookingProcessReducer.availableTimes,
    isFetchingAvailableTimes: state.bookingProcessReducer.isFetchingAvailableTimes,
    stores: state.storesReducer.list,
    covers: state.bookingProcessReducer.numberOfPeople,
    isServiceSelectedEvening: state.bookingProcessReducer.isServiceSelectedEvening,
    translations: state.settingsReducer.translations,

    availabilityTranslations: state.storeReducer.stores[state.storeReducer.storeIdSelected].availabilityTranslations,
    phone: state.storeReducer.stores[state.storeReducer.storeIdSelected].phone,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSelectTime: time => dispatch(bookingProcessSelectTime(time)),
    changeStore: (covers, date) => dispatch(changeStoreModalStart({ isOpen: true, covers, date })),
    changeSelectedService: service => dispatch(changeServiceSelected(service)),
    onNextStep: () => dispatch(bookingProcessSetStep(3)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimePicker);


// WEBPACK FOOTER //
// ./src/components/TimePicker/TimePicker.js